import { Injectable } from '@angular/core';
import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { PricerService } from '../layout/pricer/services/pricer.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private oauthService: OAuthService, private pricerService: PricerService) {
    this.oauthService.events.subscribe((event) => {
      if (event instanceof OAuthEvent) {
        if (event.type === 'token_received') {
          this.userLoginSuccess();
        }
      }
    });
  }

  public login(targetUrl?: string) {
    this.oauthService.initLoginFlow();
  }

  public logout() {
    this.oauthService.revokeTokenAndLogout();
    //this.oauthService.logOut(); 
  }
  public refresh() { this.oauthService.silentRefresh(); }
  public hasValidToken() { return this.oauthService.hasValidAccessToken(); }

  public runInitialLoginSequence() {
    this.oauthService.configure(environment.authCodeFlowConfig);
    return this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }


  userLoginSuccess() {
    this.pricerService.notifyUserLogin().subscribe({
      next: (_) => console.log('Logged in'),
      error: (e) => console.log('Login Notify Err'),
      complete: () => console.log('Login Notify Complete'),
    });
  }

  public get accessToken() { return this.oauthService.getAccessToken(); }
  public get refreshToken() { return this.oauthService.getRefreshToken(); }
  public get identityClaims() { return this.oauthService.getIdentityClaims(); }
  public get idToken() { return this.oauthService.getIdToken(); }
  public get logoutUrl() { return this.oauthService.logoutUrl; }
}

